// Centralized list of forbidden words for username/pseudo validation
// Extend this list as needed; consumers should perform case-insensitive checks.

export const forbiddenWords: string[] = [
    'adolf hitler',
    'adolfhitler',
    'baiser',
    'bander',
    'bigornette',
    'bite',
    'bitedechair',
    'bitte',
    'bloblos',
    'bordel',
    'bourré',
    'bourrée',
    'brackmard',
    'branlage',
    'branler',
    'branlette',
    'branleur',
    'branleuse',
    'brouter le cresson',
    'caca',
    'chatte',
    'chiasse',
    'chier',
    'chiottes',
    'clito',
    'clitoris',
    ' con ',
    'connard',
    'connasse',
    'conne',
    'couilles',
    'cramouille',
    ' cul ',
    'déconne',
    'déconner',
    'emmerdant',
    'emmerder',
    'emmerdeur',
    'emmerdeuse',
    'enculé',
    'enculée',
    'enculeur',
    'enculeurs',
    'enfoiré',
    'enfoirée',
    'étron',
    'fille de pute',
    'fils de pute',
    'foutre',
    'gen culki',
    'gencul ki',
    'gen culqui',
    'gerbe',
    'gerber',
    'gouine',
    'grande folle',
    'grogniasse',
    'gueule',
    'hitler',
    'jean culki',
    'jeancul ki',
    'jouir',
    'la putain de ta mère',
    'malpt',
    'ménage à trois',
    'merde',
    'merdeuse',
    'merdeux',
    'meuf',
    'nègre',
    'negro',
    'nique ta mère',
    'nique ta race',
    'palucher',
    'pédale',
    'pédé',
    'péter',
    'pipi',
    'pisser',
    'pouffiasse',
    'pousse-crotte',
    'putain',
    'pute',
    'ramoner',
    'sac à foutre',
    'sac à merde',
    'salaud',
    'salope',
    'suce',
    'tapette',
    'tanche',
    'teuch',
    'tringler',
    'trique',
    'troncher',
    'trou du cul',
    'turlute',
    'zigounette',
    'zizi',
];
